import { Navigate, Route, Routes } from "react-router-dom";
import HomePage from "./HomePage";
import InvitesPage from './InvitesPage';
import ClientsPage from './ClientsPage';
import PlansPage from './PlansPage';
import StatsPage from './StatsPage';
import MainFooter from "./MainFooter";
import Loading from "../comps/Loading";
import { useState, useEffect } from "react";
import manageareas from "../services/manageareas";
import TablesManager from "./TablesManager";
import LiveBoard from "./LiveBoard";
import ReservationCalendar from "./ReservationCalendar";
import BusinessContent from "./BusinessContent";
import ShareBooking from "./ShareBooking";
import SettingsPage from "./SettingsPage";
import SideNavbar from "./SideNavbar";
import TopNavbar from "./TopNavbar";
import BottomNav from "./BottomNav";
import { hasLive } from "../services/plan";
import managecookies from "../services/managecookies";
import LogsHub from "./LogsHub";
import SmsPage from "./SmsPage";
import WaitlistPage from "./WaitlistPage";

function MainPage() {
    const [isLoading, setLoading] = useState(true);
    const [areaLocked, setAreaLock] = useState(0)
    const liveEnabled = hasLive(); // basic plan → no visual LIVE board / floor sketch
    const [isWorker, setIsWorker] = useState(false);

    useEffect(() => {
        const data = JSON.parse(managecookies.getCookieVal('userData'));
        setIsWorker(data.business.length >= 1);
    })

    const handleAreaListReq = async () => {
        try {
            let areaList = await manageareas.getAllArea(handleFailAreaList)
            if (areaList) setLoading(false)
        } catch (error) {
            console.error('Error fetching areas:', error);
        }
    };

    const handleFailAreaList = () => {
        setLoading(false);
    };

    useEffect(() => {
        handleAreaListReq();
    }, []);

    return (
        isLoading ? (
            <Loading />
        ) : (
            isWorker ? (
                <>
                    <div className="main-page-container">
                        <div>
                            <SideNavbar />
                        </div>
                        <div className="main-page-left">
                            <TopNavbar setAreaLock={setAreaLock} isWorker={isWorker} />
                            <Routes>
                            <Route path="/" element={<HomePage />} />
                            {/* LIVE — the single day-management page for every plan: the visual
                                board on pro/live, the by-hour reservations list on basic. */}
                            <Route path="/board" element={liveEnabled ? <LiveBoard /> : <InvitesPage />} />
                            <Route path="/calendar" element={<ReservationCalendar />} />
                            <Route path="/live" element={<TablesManager areaLocked={areaLocked} />} />
                            <Route path="/waitlist" element={<WaitlistPage />} />
                            {/* Old standalone pages folded into LIVE — redirect any bookmarks. */}
                            <Route path="/invite" element={<Navigate to="/board" replace />} />
                            <Route path="/wait" element={<Navigate to="/board" replace />} />
                            <Route path="/blacklist" element={<Navigate to="/clients" replace />} />
                            <Route path="/clients" element={<ClientsPage />} />
                            <Route path="/plans" element={<PlansPage />} />
                            <Route path="/business" element={<BusinessContent />} />
                            <Route path="/share" element={<ShareBooking />} />
                            <Route path="/settings" element={<SettingsPage onUpdate={handleAreaListReq} />} />
                            <Route path="/stats" element={<StatsPage />} />
                            <Route path="/sms" element={<SmsPage />} />
                            <Route path="/logs" element={<LogsHub />} />
                            </Routes>
                        </div>
                    </div>
                    {/* MOBILE-ONLY bottom tab bar (CSS-hidden on desktop). SideNavbar + TopNavbar
                        stay for desktop; on mobile the side-nav drawer is CSS-hidden (bottomnav.css). */}
                    <BottomNav />
                    <MainFooter />
                </>
            ) : (
                <div className="text-center p-10 text-lg text-gray-700">
                    <TopNavbar setAreaLock={setAreaLock} />
                    <div>אין הרשאות </div>
                </div>
            )
        )
    );
}

export default MainPage;
